<script lang="ts">
  import { browser } from "$app/environment";
  import GetDeliveryForm from "$lib/consumer/GetDeliveryForm.svelte";

  // Get the block data
  export let blok;

  // Reference for the button element
  let getDeliveryButton: HTMLButtonElement;

  // Track whether the button has been clicked
  let deliveryButtonClicked = false;

  /**
   * Handles button clicks
   */
  function handleButtonClick() {
    deliveryButtonClicked = true;

    // Trigger the GTM click event
    if (browser && window.dataLayer) {
      window.dataLayer.push({
        event: "get_delivery_button_click",
      } as any);
    }
  }
</script>

<div class="get-delivery-button-wrapper">
  <button
    class="get-delivery-button scale-up-on-hover {deliveryButtonClicked ? 'clicked' : ''}"
    bind:this={getDeliveryButton}
    on:click={handleButtonClick}
  >
    {blok.buttonText || "Get delivery"}
  </button>
  <GetDeliveryForm standalone={false} visible={deliveryButtonClicked} />
</div>

<style type="postcss">
  .get-delivery-button-wrapper {
    width: 100%;
    position: relative;

    @screen md {
      max-width: 350px;
    }
  }

  .get-delivery-button {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 350px;
    width: 100%;
    height: 65px;
    margin-left: auto;
    margin-right: auto;
    font-family: Plain;
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
    text-decoration: none;
    text-align: center;
    color: #242021;
    border: none;
    border-radius: 2px;
    background-color: rgb(var(--color-consumer-yellow));
    cursor: pointer;
    transform-origin: center;

    &:hover {
      background-color: rgb(var(--color-consumer-yellow-bright));

      @screen md {
        transform: scale(1.02);
      }
    }

    &.clicked {
      opacity: 0;
      pointer-events: none;
    }
  }
</style>
